import { useT } from "@/i18n";
import { musicFrameMessages } from "@/i18n/messages/frames-music";

/**
 * The Spotify player: the official embed for one track (an explicit,
 * user-requested exception to the no-third-party rule; no npm dependency).
 * An iframe swallows pointer events, so it is no drag handle and its clicks
 * stay inside. At least 80px tall, Spotify's compact player.
 */
export function MusicPlayer({
  embedId,
  track,
  artist,
}: {
  embedId: string;
  track: string;
  artist: string;
}) {
  const t = useT(musicFrameMessages);
  return (
    <div
      className="nodrag h-[max(80px,3.4em)] shrink-0 overflow-hidden rounded-[0.6em]"
      data-testid="music-frame-embed-wrap"
      onClick={(event) => event.stopPropagation()}
    >
      <iframe
        src={`https://open.spotify.com/embed/track/${encodeURIComponent(embedId)}?theme=0`}
        title={t("spotifyPlayer")}
        aria-label={[t("spotifyPlayer"), track, artist]
          .filter(Boolean)
          .join(": ")}
        loading="lazy"
        allow="encrypted-media"
        data-testid="music-frame-embed"
        className="h-full w-full border-0"
      />
    </div>
  );
}
